// extracted by mini-css-extract-plugin
export var flex = "Flex-module--flex--7AvDa";
export var flexItem = "Flex-module--flex-item--19wpC";
export var debug = "Flex-module--debug--1fUBd";